import { render, staticRenderFns } from "./KBPP.vue?vue&type=template&id=61401b56&"
import script from "./KBPP.vue?vue&type=script&lang=js&"
export * from "./KBPP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports